/** Apple-standard dashboard primitives — mmjadmin palette */

export function getGreeting(date) {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) return 'Günaydın';
  if (hour >= 12 && hour < 18) return 'İyi günler';
  if (hour >= 18 && hour < 22) return 'İyi akşamlar';
  return 'İyi geceler';
}

export function getFirstName(email) {
  const local = (email || '').split('@')[0]?.trim();
  if (!local) return null;
  const part = local.split(/[._-]/)[0];
  if (!part) return null;
  return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
}

export function getUserInitial(email) {
  const trimmed = (email || '').trim();
  if (!trimmed) return '—';
  return trimmed.charAt(0).toUpperCase();
}

export function ChevronRight({ className = '' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}

export function DashIconUsers() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 00-3-3.87" />
      <path d="M16 3.13a4 4 0 010 7.75" />
    </svg>
  );
}

export function DashIconLocation() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

export function DashIconMap() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M9 18l-6-3V6l6 3 6-3 6 3v9l-6-3-6 3z" />
      <path d="M9 6v12M15 3v12" />
    </svg>
  );
}

export const SHORTCUT_META = {
  users: { subtitle: 'Hesaplar ve indirim kimlikleri' },
  shops: { subtitle: 'Adres, konum ve iletişim' },
  analytics: { subtitle: 'Büyüme ve kullanım trendleri' },
  ekip: { subtitle: 'Barista ve müdür atamaları' },
  checklist: { subtitle: 'Günlük operasyon listesi' },
};

export function MetricSkeleton() {
  return (
    <div className="dash-metric dash-metric--skeleton" aria-hidden>
      <div className="dash-shimmer dash-shimmer--line dash-shimmer--sm" />
      <div className="dash-shimmer dash-shimmer--line dash-shimmer--lg" />
      <div className="dash-shimmer dash-shimmer--line dash-shimmer--xs" />
    </div>
  );
}

export function MetricTile({
  label,
  value,
  caption,
  error,
  loading,
  icon,
  onClick,
  title,
}) {
  if (loading) return <MetricSkeleton />;

  return (
    <button
      type="button"
      className="dash-metric"
      onClick={onClick}
      title={title}
    >
      <div className="dash-metric-head">
        <span className="dash-metric-icon" aria-hidden>{icon}</span>
        <span className="dash-metric-label">{label}</span>
      </div>
      <div className="dash-metric-body">
        <span className="dash-metric-value">{value}</span>
        <span className="dash-metric-chevron" aria-hidden><ChevronRight /></span>
      </div>
      {error ? (
        <p className="dash-metric-error">{error}</p>
      ) : (
        <p className="dash-metric-caption">{caption}</p>
      )}
    </button>
  );
}

export function SettingsGroup({ label, children }) {
  return (
    <section className="dash-settings">
      {label ? <h2 className="dash-settings-label">{label}</h2> : null}
      <div className="dash-settings-card">{children}</div>
    </section>
  );
}

export function SettingsRow({ icon, label, subtitle, onClick }) {
  return (
    <button type="button" className="dash-settings-row" onClick={onClick}>
      <span className="dash-settings-row-icon" aria-hidden>{icon}</span>
      <span className="dash-settings-row-copy">
        <span className="dash-settings-row-label">{label}</span>
        {subtitle ? <span className="dash-settings-row-sub">{subtitle}</span> : null}
      </span>
      <span className="dash-settings-row-chevron" aria-hidden><ChevronRight /></span>
    </button>
  );
}

export function DashboardHero({ greeting, name }) {
  const headline = name ? `${greeting}, ${name}` : greeting;

  return (
    <header className="dash-hero">
      <h1 className="dash-hero-title">{headline}</h1>
    </header>
  );
}
